import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=e13b592a"
import script from "./AddCommentDialog.vue?vue&type=script&lang=ts"
export * from "./AddCommentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports